import type { TupleOf } from "type-fest";

export const isTupleOfLength = <T, N extends number>(
  array: T[],
  length: N
): array is TupleOf<N, T> => array.length === length;

export const isTupleOfLengthGreaterThanOrEqual = <T, N extends number>(
  array: T[],
  length: N
): array is [...TupleOf<N, T>, ...T[]] => array.length >= length;
